<script>
import { Radar } from 'vue-chartjs'
export default {
    props: {
        reportData : {

        }
    },
    extends: Radar,
    data(){
        return{
            chartData:{
                dataCollection:{
                    labels : [
                        this.$t("components.Report.ChartRadar.labels[0]"),
                        this.$t("components.Report.ChartRadar.labels[1]"),
                        this.$t("components.Report.ChartRadar.labels[2]"),
                        this.$t("components.Report.ChartRadar.labels[3]"),
                        this.$t("components.Report.ChartRadar.labels[4]"),
                        this.$t("components.Report.ChartRadar.labels[5]"),
                        this.$t("components.Report.ChartRadar.labels[6]"),
                        this.$t("components.Report.ChartRadar.labels[7]"),
                        this.$t("components.Report.ChartRadar.labels[8]"),
                        this.$t("components.Report.ChartRadar.labels[9]"),
                    ],
                    datasets: [
                        {
                            label: this.$t("components.Report.ChartRadar.datasets.label"),
                            backgroundColor: 'rgba(131, 3, 125, 0)',
                            borderColor: JSON.parse(localStorage.getItem("colors")).secondary,
                            pointBackgroundColor: JSON.parse(localStorage.getItem("colors")).secondary,
                            borderWidth: 4,
                            data: []
                            // data: [4, 3, 4, 4, 4, 1, 1, 1, 1, 1],
                        },
                        // {
                        //     label: 'Cenários',
                        //     backgroundColor: 'rgba(230, 230, 230, .7)',
                        //     borderColor: 'rgb(244, 244, 244)',
                        //     pointRadius: 0,
                        //     data: [1, 4, 3, 5, 3, 3, 4, 2, 2, 1],

                        // },
                    ],
                },
                    options:{
                        responsive: false,
                        // maintainAspectRatio: true,
                        legend: {
                            display: false,
                            position: 'top',
                            labels: {
                                fontColor: JSON.parse(localStorage.getItem("colors")).theme == 'dark' ? '#fff' : '#000'
                            },
                        },                  
                        scale: {
                            pointLabels: {
                                fontColor: JSON.parse(localStorage.getItem("colors")).theme == 'dark' ? '#fff' : '#000', // labels around the edge like 'Running'
                                fontSize: 17,
                                font: {
                                    size:100,
                                }
                            },
                            ticks: {
                                // display: false,
                                // showLabelBackdrop: false, // hide square behind text
                                maxTicksLimit: 6,
                                beginAtZero:true
                            },   
                            gridLines: {
                                color: JSON.parse(localStorage.getItem("colors")).theme == 'dark' ? '#414D58' : '#D3D3D3',
                                borderWidth: 2,
                            },          
                            angleLines: {
                                borderWidth: 2,
                                color: JSON.parse(localStorage.getItem("colors")).theme == 'dark' ? '#fff' : '#D3D3D3'
                            }              
                        },
                    },
            },
            url: `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}`,
            gameSetId: localStorage.getItem('gameSetId'),
        }
    },

    async created(){
        const { reportPlayStyle } = await this.$store.getters.getSimple(['reportPlayStyle'])
        
        let playStyle = [
            reportPlayStyle.cooperator,
            reportPlayStyle.friendly,
            reportPlayStyle.researcher, 
            reportPlayStyle.planner,
            reportPlayStyle.listener,
        ]
        this.populateRadar(playStyle)
    },
    
    async mounted(){
        await this.renderChart(this.chartData.dataCollection, this.chartData.options)
    },

    methods:{
        async populateRadar(reportData){
            // console.log(reportData)
            let maxValue = 5
            let radarChart = reportData
            reportData.forEach(reportDataItem => {
                radarChart.push(maxValue - reportDataItem)
            });
            this.chartData.dataCollection.datasets[0].data.push(
                radarChart[0],
                radarChart[9],
                radarChart[8],
                radarChart[7],
                radarChart[6],
                radarChart[5],
                radarChart[4],
                radarChart[3],
                radarChart[2],
                radarChart[1]
            )
            // console.log(this.chartData)
            this.reportData.competencesArray = this.chartData.dataCollection.datasets[0].data
            await this.renderChart(this.chartData.dataCollection, this.chartData.options)
        }
    }
}
</script>

<style lang="scss" scoped>
    #chart-header{
        height: 79vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    @media only screen and (max-width : 350px){
        canvas{
            display: block;
            height: 390px !important; 
            width: 300px !important;
            margin: 5% auto 0;
        }
    }

    @media only screen and (max-width : 500px){
        canvas{
            display: block;
            height: 380px !important; 
            width: 355px !important;
            margin: 0 auto;
        }
    }

    @media only screen and (min-width : 750px){
        canvas{
            // margin-top: 50px;
            margin: 0 auto;
        }
    }
</style>